module.exports = __webpack_public_path__ + "static/img/blog-31.f81ecfb8.png";